/**
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
//console.log( 'Hello World! (from digital-hill-dhwp-offcanvas-menu block)' );

jQuery.noConflict();
 
    jQuery( document ).ready(function( $ ) {

        var current_selector = "";
        current_selector = $('.hamburger').eq(0).data('offcanvasselector');

        show_hide_main_nav();

        if(typeof current_selector == "undefined" || current_selector == "") {
            current_selector = ".dh-offcanvas";
        }

        var current_direction = "";
        current_direction = $('.hamburger').eq(0).data('offcanvasdirection');
        console.log("current_direction:", current_direction);

        if(current_direction == "bottom") {
            $(".dh-offcanvas").addClass('bottom');
        }
        if(current_direction == "left") {
            $(".dh-offcanvas").addClass('left');
        }
        if(current_direction == "right") {
            $(".dh-offcanvas").addClass('right');
        }

        if(typeof current_direction == "undefined" || current_direction == "") {
            current_direction = "top";
        }

        // Clone offcanvas. Now deprecated, works without cloning.
        //$(".offcanvas").eq(0).remove().clone(true).appendTo(document.body);
        //$(current_selector).eq(0).remove().clone(true).addClass(current_direction).appendTo(document.body);

        $(".hamburger").click(function(){

            //console.log("hamburger click client side");

            // Check for offcanvasSelector
            var offcanvas_selector = "";
            offcanvas_selector = $(this).data('offcanvasselector');
            //console.log('offcanvas_selector: '); //console.log(offcanvas_selector);

            if(typeof offcanvas_selector == "undefined" || offcanvas_selector == "") {
                offcanvas_selector = ".dh-offcanvas";
            }

            

            // Check if parent has "demo" class.

            var demo_sib = $(this).siblings('.demo');
            //console.log("demo_sib:"); //console.log(demo_sib);

            var sib_has_demo = demo_sib.hasClass('demo');
            //console.log('sib_has_demo: '); //console.log(sib_has_demo);

            if(sib_has_demo) {
                $(this).toggleClass('is-active');
            }
            else {

                // Get the current hamburger state.
                // This state could come from the original or the clone.
                var elem = $(this);
                //console.log( $(this) );
                var is_active = elem.hasClass('is-active');
                //console.log('is_active: '); //console.log(is_active);

                // Offcanvas is open.
                if(is_active) {

                    $(document.body).css('overflow-y','auto');

                    $("header .hamburger").removeClass('is-active');

                    $("body > .hamburger").removeClass('is-active');

                    setTimeout(function() {
                        
                        /* $('.offcanvas').eq(0).toggleClass('is-active'); */
                        $(offcanvas_selector).eq(0).toggleClass('is-active');

                        
                        
                    }, 310);

                    setTimeout(function() {
                        $("body > .hamburger").fadeOut("fast");
                        $("body > .hamburger").remove();
                    }, 720);

                }
                // Offcanvas is closed.
                else {
                    // Animate the hamnburger.
                    $("header .hamburger").addClass('is-active');

                    // Prevent scroll.
                    $(document.body).css('overflow-y','hidden');
                    
                    // Allow enough delay for the button animation. Currently 300ms
                    setTimeout(function() {

                        // Check if header is stickied or not.
                        var is_stickied = $('.sticky-wrapper').eq(0).hasClass('is-sticky');
                        //console.log('is_stickied: '); //console.log(is_stickied);

                        // Calculate top position, considering header may or may not be fixed position.
                        var adminbar = document.getElementById("wpadminbar");
                        var top_bun = 0;

                        if(adminbar) {
                            top_bun += 32;
                        }
                        //console.log("top_bun after admin bar calc:", top_bun);

                        if(is_stickied) {
                            // Now clone the button (and set its state).
                            var hamburgerOffset = $("header .hamburger").position();
                            
                            top_bun += hamburgerOffset.top;
                        }
                        else {
                            var hamburgerOffset = $("header .hamburger").offset();
                            top_bun = hamburgerOffset.top;
                        }

                        
                        //console.log("hamburgerOffset: ", hamburgerOffset);
                        $("header .hamburger").clone(true).appendTo(document.body);

                        // Set clone hamburger to same position as original.
                        $("body > .hamburger").css('top', top_bun+"px");
                        $("body > .hamburger").css('left', hamburgerOffset.left+"px");
                        $("body > .hamburger").css('z-index', '999');


                    }, 310);

                    // Allow enough delay for the offcanvas to open. 
                    setTimeout(function() {

                        
                        // Open the offcanvas.
                        /* $('.offcanvas').eq(0).addClass('is-active'); */
                        $(offcanvas_selector).eq(0).addClass('is-active');
                        
                    }, 350);
                }
            }
        });

        $( window ).on( "resize", function() {
            matchBurger();

        });

        function show_hide_main_nav() {
            //console.log("show_hide_main_nav");

            // Check for navigationSelector 
            var navigation_selector = "";
            navigation_selector = $('.hamburger').eq(0).data('navigationselector');
            //console.log('navigation_selector: '); //console.log(navigation_selector);

            if(typeof navigation_selector == "undefined" || navigation_selector == "") {
                navigation_selector = ".dhwp-main-navigation";
            }
        }

        function matchBurger() {
            var hamburgerOffset = $("header .hamburger").eq(0).offset();
            //console.log("hamburgerOffset: ", hamburgerOffset);
    
            // Set clone hamburger to same position as original.
            $("body > .hamburger").eq(0).css('top', hamburgerOffset.top+"px");
            $("body > .hamburger").eq(0).css('left', hamburgerOffset.left+"px");
        }

        function matchBurgerScroll() {
            // Instead of offset, but get distance to top of viewport or maybe just distance to top of element will do?
            //console.log("fn matchBurgerScroll");

            var scrollTop = $(window).scrollTop();
            //console.log('scrollTop: '); //console.log(scrollTop);

            var hamburgerPosition = $("header .hamburger").eq(0).position();
            //console.log('hamburgerPosition: '); //console.log(hamburgerPosition);

            // Set clone hamburger to same position as original.
            $("body > .hamburger").eq(0).css('top', hamburgerPosition.top+"px");
            $("body > .hamburger").eq(0).css('left', hamburgerPosition.left+"px");
        }
    });
/* eslint-enable no-console */